export const workspacePerformanceMarks = {
  navigationStart: "qy:navigation-start",
  shellReady: "qy:shell-ready",
  routeDataReady: "qy:route-data-ready",
  primaryReady: "qy:primary-ready",
  secondarySettled: "qy:secondary-settled",
} as const;

export type WorkspacePerformanceMark = typeof workspacePerformanceMarks[keyof typeof workspacePerformanceMarks];

export function markWorkspacePerformance(mark: WorkspacePerformanceMark) {
  if (typeof performance === "undefined" || typeof performance.mark !== "function") return;
  performance.clearMarks(mark);
  performance.mark(mark);
}

export function measureWorkspacePerformance(name: string, from: WorkspacePerformanceMark, to: WorkspacePerformanceMark) {
  if (typeof performance === "undefined" || typeof performance.measure !== "function") return null;
  if (!performance.getEntriesByName(from, "mark").length || !performance.getEntriesByName(to, "mark").length) return null;
  performance.clearMeasures(name);
  performance.measure(name, from, to);
  return performance.getEntriesByName(name, "measure").at(-1) ?? null;
}
